<style lang="sass" scoped>
::v-deep .el-select__tags
  max-width: 90% !important
.cityClass
  ::v-deep .el-select
    width: 190px !important
  ::v-deep .el-input
    width: 190px !important
  ::v-deep .el-select__tags
    height: 20px !important


::v-deep .dist_input
  width:230px
  height: 28px !important
  line-height:28px !important
  > i
    top: 8px !important


.cover_ctn
  position: relative
.ctn
  border: 1px solid #D4D4D4
  border-radius: 4px
  line-height: 1
  height: 42px
  background: #fff
  border-bottom: 1px solid #D4D4D4
  border-left: none
  position: relative
  z-index: 2
  > .fr
    margin-top: 15px
    position: relative
    z-index: 2
    .el-icon-caret-bottom
      &.open
        transform: rotate(180deg)
    .more
      display: inline-block
      padding-right: 20px
      border-right: 1px solid #D4D4D4
      color: #999
      cursor: pointer
    .btns
      padding: 0 10px
      // border-left: 1px solid #D4D4D4
      span
        cursor: pointer
        margin: 0 10px
  .cover
    position: absolute
    z-index: 1
    top: 0
    left: 0
    width: 100%
    border: 1px solid #d4d4d4
    background: #fff

  .left_fl
    float: left
    width: calc(100% - 190px)
    overflow: hidden
    height: 100%
    position: relative
    z-index: 2
    &.open
      overflow: visible
    .items-ctn
      // height: 100%
      overflow: hidden
      position: relative
      z-index: 1
      border-left: 1px solid #D4D4D4
      .item
        height: 41px
        padding: 10px
        border-right: 1px solid #D4D4D4
        background: #fff
        border-bottom: 1px solid #D4D4D4
        float: left
        span
          display: inline-block
          border-right: 1px solid #D4D4D4
          padding-right: 10px
        ::v-deep .el-input, ::v-deep .el-select
          width: 120px
          input
            height: 20px
            border: none
            padding-right: 0
          .el-select__caret
            height: auto
            position: relative
            top: -3px
        // height: 12px
        ::v-deep .el-date-editor
          width: 200px
          padding: 0 10px
          border: none
          height: 20px
          input
            width: 80px
            height: 20px
            border: none
            padding-right: 0
          .el-input__icon
            display: none
          .el-range-separator
            width: 20px
</style>

<template lang="pug">
.cover_ctn
  .ctn
    .left_fl(:class="{'open': isOpen}")
      .items-ctn(ref="itemCtn" width="100%")
        .item
          span 订单编号
          el-input(size="mini" placeholder="请输入" v-model="searchOpt.orderCode" @keyup.enter.native="searchFn(1)")
        .item
          span 广告名称
          el-input(size="mini" placeholder="请输入" v-model="searchOpt.contentName" @keyup.enter.native="searchFn(1)")
        .item
          span 创建人
          el-input(size="mini" placeholder="请输入" v-model="searchOpt.creatorName" @keyup.enter.native="searchFn(1)")
        .item
          span 合同编码
          el-input(size="mini" placeholder="请输入" v-model="searchOpt.contractNo" @keyup.enter.native="searchFn(1)")
        .item
          span 订单状态
          el-select(v-model="searchOpt.orderStatus" size="mini" placeholder="请选择")
            el-option(v-for="(item, i) in statustypes" :key="i" :label="item.dictItemName" :value="item.dictItemCode")
        .item
          span 预计投放日期
          el-date-picker(
            value-format="yyyy-MM-dd"
            v-model="playTime" size="mini" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          )
        .item
          span 类型
          el-select(placeholder="请选择" size="mini" v-model="searchOpt.screenArea" @visible-change="orderVisible")
            el-option(v-for="item in orderTypes" :key="item.dictItemCode" :label="item.dictItemName" :value="item.dictItemCode")
        //- .item
        //-   span 投放方案
        //-   el-select(placeholder="请选择" size="mini" v-model="searchOpt.orderTypes" @visible-change="orderVisible")
        //-     el-option(v-for="p in orderTypes" :key="p.value" :label="p.label" :value="p.value")
        //- .item
        //-   span 广告类型
        //-   el-select(placeholder="请选择" size="mini" v-model="searchOpt.advertTypes" @visible-change="advertVisible")
        //-     el-option(v-for="p in advTypes" :key="p.value" :label="p.label" :value="p.value")
        .item
          span 下单时间
          el-date-picker(
            value-format="yyyy-MM-dd"
            v-model="createTime" size="mini" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          )
        .item
          span 屏幕位置
          el-select(v-model="searchOpt.showScreenType" size="mini" placeholder="请选择")
            el-option(v-for="(item, i) in orderSnTypes" :key="i" :label="item.dictItemName" :value="item.dictItemCode")
        .item(style="display:flex;align-items:center;" class='cityClass')
          span 城市
          //- MultCityAsync(ref="cityChoose" @change="getAddressCodes")
          el-select(v-model="searchOpt.cityCodes" size="mini" placeholder="请选择" clearable  multiple collapse-tags  filterable )
            el-option(v-for="(item, i) in cityList" :key="i" :label="item.dictItemName" :value="item.dictItemCode")
        .item
          span 订单组别
          el-date-picker(
            v-model="searchOpt.dateList"
            type="daterange"
            size='small'
            clearable
            range-separator="至"
            value-format='yyyy-MM-dd'
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            )
        .item
          span 组别tag
          el-input(size="mini" placeholder="请输入"  v-model="searchOpt.orderGroupTagLike" @keyup.enter.native="searchFn(1)")

    .fr
      span.more(v-if="showMore" @click="isOpen = !isOpen")
        i.el-icon-caret-bottom(:class="{'open': isOpen}")
        span 更多
      .fr.btns
        span(style="color: #FF3973;" @click="searchFn(1)") 搜索
        span(@click="searchFn('')") 重置

  .cover(v-if="isOpen" :style="{ height: coverH + 'px' }")
</template>

<script>
import { mapState } from "vuex"

export default {
  name: 'ListSearchCp',
  props: {
    orderTagList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isOpen: false,
      orderTypes: [],
      // advTypes: [],
      orderSnTypes: [],
      statustypes: [],
      searchOpt: {
        creatorName: ''
      },
      playTime: [],
      createTime: [],
      showMore: true,
      cityList: [],
      coverH: 0
    }
  },
  computed: {
    ...mapState({
      adUser: s => {
        return s ? s.customer.userInfo : {}
      }
    })
  },
  watch: {
    isOpen(v) {
      if (v) {
        this.coverH = this.$refs.itemCtn.clientHeight + 1
      }
    },
    playTime (v) {
      this.searchOpt.playStartDate = v && v[0] || ''
      this.searchOpt.playEndDate = v && v[1] || ''
    },
    createTime (v) {
      this.searchOpt.createStartDate = v && v[0] || ''
      this.searchOpt.createEndDate = v && v[1] || ''
    },
    'adUser.userName': {
      immediate: true,
      handler (v) {
        if (v && v.length) {
          this.searchOpt.creatorName = v
          this.$emit('change', this.searchOpt)
        }
      }
    }
  },
  created () {
    this.getTypes()
  },
  mounted () {
    this.$nextTick(() => {
      this.handleMoreShow()
      this.getCityCodesList()
      window.addEventListener('resize', this.handleMoreShow)
      this.$root.$on('rootEmitCloseLeft', () => {
        setTimeout(() => {this.handleMoreShow() }, 200)
      })
    })
  },
  methods: {
    // 获取城市列表
    async getCityCodesList() {
      const result = await this.fetch('config/api/v3/region/district-list?deviceCode=33554688&levelNum=3', '', 'get')
      if (result.code === 0) {
        this.cityList = result.data.map(s => {
          return {
            dictItemCode: s.districtCode,
            dictItemName: s.districtValue
          }
        })
      } else {
        this.cityList = []
      }

    },

    getAddressCodes(data, initData) {
      if (initData) {
        this.searchOpt.cityCodes = initData
        return
      }
      this.searchOpt.cityCodes = data.map(s => s.code)
    },

    async orderVisible (v) {
      // let typeArr = this.$store.state.common.orderTypes
      // if (v && !typeArr.length) {
      //   await this.$store.dispatch('getPutOrderType')
      //   typeArr = this.$store.state.common.orderTypes
      //   if (typeArr.length) this.orderTypes = [{ label: '全部', value: '' }].concat(typeArr)
      // }
      let typeArr = this.$store.state.common.orderTypes
      if (!typeArr.length) {
        let load = this.$loading()
        await this.$store.dispatch('getDictItemListFromUrl', { key: 'orderTypes', url: '/boss/common/config/v2/getOrderScreenArea' })
        load.close()
        typeArr = this.$store.state.common.orderTypes
      }
      if (typeArr.length) this.orderTypes = [{ dictItemName: '全部', dictItemCode: '' }].concat(typeArr)
    },
    // async advertVisible (v) {
    //   let typeArr = this.$store.state.common.advertTypes
    //   if (v && !typeArr.length) {
    //     await this.$store.dispatch('getAdvertType')
    //     typeArr = this.$store.state.common.advertTypes
    //     if (typeArr.length) this.advTypes = [{ label: '全部', value: '' }].concat(typeArr)
    //   }
    // },
    handleMoreShow () {
      if (this.$refs.itemCtn && this.$refs.itemCtn.clientHeight > 50) this.showMore = true
      else this.showMore = false
    },
    searchFn (type) {
      if (!type) {
        this.searchOpt = {}
        this.playTime = []
        this.createTime = []
      } else {
        if (this.searchOpt.dateList?.length) {

          this.searchOpt.orderGroupStartDate = this.searchOpt.dateList[0]
          this.searchOpt.orderGroupEndDate = this.searchOpt.dateList[1]
          delete this.searchOpt.dateList
        }
        if (!this.searchOpt.orderGroupTagLike) {
          delete this.searchOpt.orderGroupTagLike
        }
      }
      this.$emit('change', this.searchOpt)
    },
    async getTypes() {
      let load = this.$loading()
      let res = await this.fetch('/boss/common/config/v2/getOrderStatusTab', '', 'get')
      load.close()
      if (res && res.code === 0) {
        let data = res.data || []
        if (data.length) this.statustypes = [{ dictItemName: '全部', dictItemCode: '' }].concat(data)
      }

      let orderSnTypes = this.$store.state.common.orderSnTypes
      if (!orderSnTypes.length) {
        let load = this.$loading()
        await this.$store.dispatch('getDictItemListFromUrl', { key: 'orderSnTypes', url: '/boss/common/config/v2/getOrderScreenType' })
        load.close()
      }
      this.orderSnTypes = [{ dictItemName: '全部', dictItemCode: '' }].concat(this.$store.state.common.orderSnTypes)

    }
  }
}
</script>
